import { render, staticRenderFns } from "./ApplicantDependent.vue?vue&type=template&id=7c857c58&scoped=true&"
import script from "./ApplicantDependent.vue?vue&type=script&lang=js&"
export * from "./ApplicantDependent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c857c58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c857c58')) {
      api.createRecord('7c857c58', component.options)
    } else {
      api.reload('7c857c58', component.options)
    }
    module.hot.accept("./ApplicantDependent.vue?vue&type=template&id=7c857c58&scoped=true&", function () {
      api.rerender('7c857c58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/components/Apply/ApplicantDependent.vue"
export default component.exports